export default __webpack_public_path__ + "a84e6f38cd9506f31c25fa2787b94382.png";